import React, { useEffect, useState, useRef } from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import PropTypes from 'prop-types';
import '../styles/footer.scss';
import formStyles from '../styles/forms.module.scss';
import classNames from 'classnames';
import GreenwichLogo from './greenwich-logo';
import SocialButtons from './social-buttons';
import FooterChevrons from './footer-chevrons';
import SignUpForm from './sign-up-form';
import SignUpTab from './sign-up-tab';

const Footer = ({ isInHome }) => {
  const data = useStaticQuery(graphql`
    query FooterQuery {
      contact: sanityContactDetails {
        address
        city
        email
        phone
        postcode
        street
      }
      
      footer: sanityFooter {
        googleMapsUrl
        introMessage
        showForm
        showCrossrail
        formTitle
        formIntroText
        formLaunchButtonText
      }
      
      venue: sanityVenueHire {
        title
      }
      
      happening: sanityWhatsHappening {
        title
      }
      
      history: sanityHistoryOfTheArsenal {
        title
      }

      residentCompanies: sanityP2CompaniesPage {
        title
      }
      
      cookies: sanityLegal(id: {eq:"758565eb-3fe1-5b82-971a-c491caccfd3b"}) {
        footerTitle
      }
      
      privacy: sanityLegal(id: {eq:"7a686698-6eda-555d-b604-158d19c52f1b"}) {
        footerTitle
      }
      
      terms: sanityLegal(id: {eq:"7aa9da6a-daa3-59c9-ac65-9475d62493f5"}) {
        footerTitle
      }
      
      about: sanityP2About(id: { eq: "1f486191-08f3-581c-8994-690521266d41" }) {
        title
      }

      takePart: sanityCommunity( id: { eq: "b91facc9-d363-568b-b6b1-3086d969b3d4" }) {
        title
      }
    },
  `);

  const [showPopupForm, setShowPopupForm] = useState(false);
  const emailInputRef = useRef(null);

  const handleClosePopupForm = () => {
    setShowPopupForm(false);
  }

  const handleManageCookies = (e) => {
    e.preventDefault();
    window.Metomic('ConsentManager:show');
  }

  return (
    <>
      <footer className={`strip ${!isInHome ? 'strip--pad-top-big' : ''}`}>
        {/*© {new Date().getFullYear()} Woolwich Works*/}

        {
          data.footer.showForm &&
          <div className='strip keep-in-touch'>
            <div className='strip__middle pad-sides keep-in-touch__inner'>
              <div className='keep-in-touch__email-form'>
                <div className='keep-in-touch__title'>{data.footer.formTitle}</div>
                <div className='keep-in-touch__intro'>{data.footer.formIntroText}</div>

                <div className='keep-in-touch__email-harness'>
                  <input 
                    ref={emailInputRef} 
                    className={classNames(formStyles.input, formStyles.inputEmailBox)} 
                    type="email" 
                    name="email" 
                    placeholder='Your email' 
                    maxLength={60}
                  />
                  <button onClick={(e) => {
                    e.preventDefault();
                    setShowPopupForm(true);
                  }} className={classNames('button', formStyles.signUpButton, formStyles.emailButton)}>
                    {data.footer.formLaunchButtonText} →
                  </button>
                </div>
              </div>
            </div>
            <div className='keep-in-touch__chevrons-grid'>
              <div className='keep-in-touch__chevrons-left' />
              <FooterChevrons />
            </div>
          </div>
        }

        {
          !data.footer.showForm &&
          <FooterChevrons fit />
        }

        <div className={`strip footer__map ${!data.footer.showCrossrail ? 'footer__map--no-crossrail' : ''}`} />

        <div className='strip footer'>
          <div className='strip__middle pad-sides footer-content'>
            <div className='footer-content__left'>
              <Link className='footer__section-link' to='/whats-happening'>{data.happening.title}</Link>
              <Link className='footer__section-link' to='/venue-hire'>{data.venue.title}</Link>
              <Link className='footer__section-link' to='/woolwich-stories'>{data.history.title}</Link>
              <Link className='footer__section-link' to='/about/resident-companies'>{data.residentCompanies.title}</Link>
              <Link className='footer__section-link' to='/take-part'>{data.takePart.title}</Link>
              <Link className='footer__section-link' to='/about'>{data.about.title}</Link>
            </div>

            <div className='footer-content__middle'>
              <div>
                {
                  data.contact.phone &&
                  <a className='footer__contact-link' href={`tel:${data.contact.phone}`}>{data.contact.phone}</a>
                }

                {
                  data.contact.email &&
                  <a className='footer__contact-link' href={`mailto:${data.contact.email}`}>{data.contact.email}</a>
                }

                {
                  data.footer.introMessage &&
                  <div className='footer__opening'>{data.footer.introMessage}</div>
                }

                {
                  data.contact.address &&
                  <div className='footer__address'>
                    {data.contact.address}<br />
                    {
                      data.contact.street &&
                      <>{data.contact.street}<br /></>
                    }
                    {
                      data.contact.city &&
                      <>{data.contact.city}<br /></>
                    }
                    {
                      data.contact.postcode &&
                      <>{data.contact.postcode}<br /></>
                    }
                  </div>
                }

                {
                  data.footer.googleMapsUrl &&
                  <a className='footer__contact-link footer__google-maps-link' target='_blank' href={data.footer.googleMapsUrl}>Open in Google Maps ↗</a>
                }

              </div>
              <div className='footer__social'>
                <SocialButtons />
              </div>
            </div>

            <div className='footer-content__right'>
              <div>
                {/*<Link className='footer__contact-link' to='/cookies'>{data.legal.footerTitle}</Link>*/}
                <Link className='footer__contact-link' to='/cookies'>{data.cookies.footerTitle}</Link>
                <a onClick={handleManageCookies} className='footer__contact-link'>Manage cookies</a>
                <Link className='footer__contact-link' to='/privacy'>{data.privacy.footerTitle}</Link>
                <Link className='footer__contact-link' to='/terms'>{data.terms.footerTitle}</Link>
                {/*<Link className='footer__contact-link' to='/legal'>Legal</Link>*/}
              </div>
              <div className="footer__from">
                From the Royal Borough of Greenwich, for everyone
              <a href='https://www.royalgreenwich.gov.uk' target='_blank'>
                <GreenwichLogo classes='footer__greenwich-logo' />
              </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {
        isInHome &&
        <SignUpTab handleClick={() => setShowPopupForm(true)} />
      }    
      {
        showPopupForm &&
        <SignUpForm 
          emailFromPage={emailInputRef.current ? emailInputRef.current.value : ''} 
          handleClose={handleClosePopupForm} 
        />
      }
    </>
  );
}

Footer.propTypes = {
  isInHome: PropTypes.bool
};

Footer.defaultProps = {
  isInHome: false
};

export default Footer;
